export enum AppInitializationStatus {
  initializing = 'initializing',
  consoleUp = 'consoleUp',
  consoleDown = 'consoleDown',
  fail = 'fail',
}